import { TranslationFieldPipe } from 'src/app/shared/pipes/translation-value.pipe';
import { BasicDropdownType, TableCols } from '../interfaces/static-data';
import { SENIORITY_LEVEL_ITEMS } from './reference-obligation';
import { mapToDropdownItem } from './static-data.utils';

export const OBLIGATION_CATEGORY_ITEMS: BasicDropdownType[] = mapToDropdownItem(
  ['PAYMENT', 'BORROWED_MONEY', 'BOND', 'LOAN', 'BOND_OR_LOAN']
);

export const OBLIGATION_CHARACTERISTICS_ITEMS: BasicDropdownType[] =
  mapToDropdownItem([
    'NOT_SUBORDINATED',
    'SPECIFIED_CURRENCY',
    'SPECIFIED_CURRENCY_STANDARD_SPECIFIED_CURRENCIES',
    'SPECIFIED_CURRENCY_STANDARD_SPECIFIED_CURRENCIES_AND_DOMESTIC_CURRENCY',
    'NOT_SOVEREIGN_LENDER',
    'NOT_DOMESTIC_CURRENCY',
    'NOT_DOMESTIC_LAW',
    'LISTED',
    'NOT_DOMESTIC_ISSUANCE',
  ]);


  const translationPipe = new TranslationFieldPipe();

export const REFERENCE_ENTITY: TableCols[] = [
  {
    key: 'longName',
    displayValue: 'Reference Entity Name',
    type: 'translate',
    valueGetter: ({ data }) => translationPipe.transform(data?.longName),
  },
  {
    key: 'seniorityLevel',
    displayValue: 'Seniority Level',
    type: 'select',
    items: SENIORITY_LEVEL_ITEMS,
    selectOptions: {
      searchable: true,
    },
  },
  {
    key: 'transactionType',
    displayValue: 'Transaction Type',
    type: 'select',
    items: [],
    selectOptions: {
      searchable: true,
    },
  },
  {
    key: 'moodysRating',
    displayValue: "Moody's Rating",
  },
  {
    key: 'moodysRatingEffectiveDate',
    displayValue: "Moody's Rating Effective Date",
    type: 'date',
    mask: '0000-00-00',
  },
  {
    key: 'spRating',
    displayValue: 'S&P Rating',
  },
  {
    key: 'spRatingEffectiveDate',
    displayValue: 'S&P Rating Effective Date',
    mask: '0000-00-00',
    type: 'date',
  },
  {
    key: 'fitchRating',
    displayValue: 'Fitch Rating',
  },
  {
    key: 'fitchRatingEffectiveDate',
    displayValue: 'Fitch Rating Effective Date',
    mask: '0000-00-00',
    type: 'date',
  },
  {
    key: 'currency',
    displayValue: 'Currency',
    type: 'select',
    selectOptions: {
      searchable: true,
    },
  },
  {
    key: 'domesticCurrency',
    displayValue: 'Domestic Currency',
    type: 'select',
    selectOptions: {
      searchable: true,
    },
  },
  {
    key: 'restructuring',
    displayValue: 'Restructuring',
    type: 'select',
    items: [
      { id: 'MOD_R', displayValue: 'Modified Restructuring' },
      { id: 'MOD_MOD_R', displayValue: 'Modified Modified Restructuring ' },
      { id: 'NO_RESTRUCTURING', displayValue: 'No Restructuring' },
      { id: 'FULL_RESTRUCTURING', displayValue: 'Full Restructuring' },
    ],
  },
  {
    key: 'website',
    displayValue: 'Website',
    type: 'translate',
    valueGetter: ({ data }) => translationPipe.transform(data?.website),
  },
  {
    key: 'description',
    displayValue: 'Description',
    type: 'translate',
    valueGetter: ({ data }) => translationPipe.transform(data?.description),
  },
  {
    key: 'workflowStatus',
    displayValue: 'Workflow Status',
    hideOnForm: true
  },
  {
    key: 'lastUpdatedBy',
    displayValue: 'Last Updated By',
    hideOnForm: true
  },
  {
    key: 'updatedOn',
    displayValue: 'Updated On',
    hideOnForm: true
  },
  {
    key: 'deletedAt',
    displayValue: 'Deleted On',
    hideOnForm: true
  },
];
